import * as React from "react";

import "./viewing.scss";

import {cs}    from "@Common/react/chain-services";
import {Radio} from "@Common/ui-components/heavy/common/design2/radio/radio";

import {ErrorNotExists} from "./error-not-exists/error-not-exists";

export const Viewing = ({idMailer, idMailClass, onEdit, showErrors}) => cs(
    ({}, next) => !idMailer ? ErrorNotExists({onEdit, showErrors}) : next(),
    ({}, next) => (
        <div className="viewing-653">
            {next()}
        </div>
    ),
    ({}) => <>
        <div className="left">
            <div className="title" xd-qa-type="label" xd-qa-name="IMb ready to use">
                IMb ready to use
            </div>

            <div className="content has-permit">
                <div className="message" xd-qa-type="label" xd-qa-name="Mailer ID">
                    Mailer ID: {idMailer}
                </div>
                <div className="question" xd-qa-type="label" xd-qa-name="Do you want to update it">
                    Do you want to update it?{" "}
                </div>
                <a
                    className="link"
                    target="_blank"
                    href={"https://pe.usps.com/text/DMM300/204.htm"}
                    xd-qa-type="link"
                    xd-qa-name="Mailer ID Learn More"
                >Learn More</a>

                <div className="actions">
                    <button {...{
                        onClick: onEdit,
                    }}
                        xd-qa-type="button"
                        xd-qa-name="Edit"
                    >EDIT</button>
                </div>
            </div>
        </div>

        <div className="right">
            <div className="title" xd-qa-type="label" xd-qa-name="Select Intended Mailing Service">
                Please Select Your Intended Mailing Service Level Below
            </div>
            <div className="description" xd-qa-type="label" xd-qa-name="Descritpion">
                The mailing service level selected below must match the service assigned IMb.
                If the methods do not match, the USPS will not deliver your materials.{" "}
                <a
                    target="_blank"
                    href={"https://postalpro.usps.com/mailing/service-type-identifiers"}
                    xd-qa-type="link"
                    xd-qa-name="Service Type Learn More"
                >Learn more</a>
            </div>

            <div className="choices">
                {[
                    {
                        text: "I will be mailing my materials via USPS First Class Mail",
                        value: "1",
                        xdQaName: "First Class Mail",
                    },
                    {
                        text: "I will be mailing my materials via USPS Standard Mail",
                        warning: "Standard Mail is not available on small postcards",
                        value: "3",
                        xdQaName: "Standard Mail",
                    },
                ].map(({text, warning, value, xdQaName}, i) => (
                    <div className="choice" key={i} onClick={() => idMailClass.onChange(value)}>
                        {Radio({
                            selected: value === idMailClass.value,
                            xdQaName: xdQaName
                        })}

                        <div className="text">
                            {text}
                        </div>
                        {warning && (
                            <div className="warning" xd-qa-type="text" xd-qa-name="Warning">
                                ({warning})
                            </div>
                        )}
                    </div>
                ))}
            </div>

        </div>
    </>,
);

